// src/pages/HomePage/HomePage.jsx
import React from 'react';
import Body from '../../components/Body/Body';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="homepage">
      <section className="main-section">
        <Body />
      </section>
    </div>
  );
};

export default HomePage;